export default '/build/0ea42ac7.svg'